import { ThemeProvider } from '@fairygodboss/ui';
import type { AppProps } from 'next/app';
import Head from 'next/head';
import React from 'react';

import { ModalTrigger } from '../components/Auth/ModalTrigger';
import Layout from '../components/Layout';
import '../styles/base.scss';
import '../styles/_vars.scss';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-quill/node_modules/quill/dist/quill.snow.css';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'regenerator-runtime/runtime';
import {
    createMetaTags,
    createPreloadTags,
    createSocialMediaTags,
} from '../components/Seo';

const FGBApp = ({ Component, pageProps }: AppProps) => (
    <>
        <Head>
            {createMetaTags()}
            {createSocialMediaTags()}
            {createPreloadTags()}
        </Head>
        <link
            href="https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700;800&display=swap"
            rel="stylesheet"
        />
        <ThemeProvider>
            <Layout pageProps={pageProps}>
                <ModalTrigger />
                <Component {...pageProps} />
            </Layout>
        </ThemeProvider>
    </>
);

export default FGBApp;
